module.exports = __webpack_public_path__ + "img/20200507_134743.a0dac8ce.jpg";